export default "__VITE_ASSET__023b915b__"